<template>
  <div>
    <div v-if="pageLoading">
      <t-container class=" flex justify-center items-center py-20">
        <div class="animate-spin rounded-full h-10 w-10 mr-4 border-b-2 border-matte-gray" />
        <h6>Loading...</h6>
      </t-container>
    </div>
    <div v-else>
      <t-dialog v-model:open="showLoginModal">
        <t-dialog-content class="max-w-xl bg-white">
          <t-login-form />
        </t-dialog-content>
      </t-dialog>
      <div id="subOptions">
        <l-aside-transition
          :selected-session="selectedSession"
          :selected-format="selectedFormat"
          :show="showModal"
          :subscriptions="selectedSession.allowedSubscriptions"
          :is-valid-subscription="isValidSubscription()"
          :loading="loading"
          :redirect-loading="redirectLoading"
          :loading-item="loadingItem"
          :is-brochure="isBrochure"
          :btn-state="btnState"
          :is-two-hours-before-start-time="isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone)"
          :is-included-in-subscription="isIncludedInSubscription(selectedSession)"
          :course-test="courseExperiment === 'B'"
          :check-item-selected="checkItemSelected()"
          @show-purchase="showModal = !showModal"
          @add-to-subscription="addToSubscription(selectedSession)"
          @proceed-to-checkout="proceedToCheckout()"
          @add-item-to-cart="addItemToCart()"
          @go-to-live="goToLive()"
          @subscribe-now="subscribeNow"
          @add-cart-item="addCartItem(selectedSession)"
        >
          <template #closeButton>
            <div @click.prevent="showModal = false">
              <h3 class="text-accent-light">
                X
              </h3>
              <p class="text-xs leading-tight text-white">
                Close <br /> Window
              </p>
            </div>
          </template>
        </l-aside-transition>
      </div>
      <div class="relative">
        <div>
          <course-title-hero
            v-if="courseExperiment === 'B'"
            :selected-session="selectedSession"
            :ratings="ratings"
            :selected-format="selectedFormat"
            :master-course-id="masterCourseId"
            :thumbnail="thumbnail"
            :course-title="title"
            :preview-id="previewId"
            :path-details="{ $route, from }"
            :is-valid-subscription="isValidSubscription()"
            :loading="loading"
            :redirect-loading="redirectLoading"
            :loading-item="loadingItem"
            :is-brochure="isBrochure"
            :btn-state="btnState"
            :is-two-hours-before-start-time="isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone)"
            :is-included-in-subscription="isIncludedInSubscription(selectedSession)"
            :check-item-selected="checkItemSelected()"

            @show-purchase="showModal = !showModal"
            @add-to-subscription="addToSubscription(selectedSession)"
            @proceed-to-checkout="proceedToCheckout()"
            @add-item-to-cart="addItemToCart()"
            @go-to-live="goToLive()"
          />
        </div>
        <t-container class="px-5 md:py-10">
          <div class="md:grid md:grid-flow-col md:grid-cols-2 md:grid-rows-1 md:gap-4">
            <div class="md:border-r-2 border-matte-gray mt-2 md:mt-0">
              <l-title-preview
                :selected-session="selectedSession"
                :ratings="ratings"
                :selected-format="selectedFormat"
                :cert-series="certSeries"
                :is-brochure="isBrochure"
                :asha-review="ashaReview"
                :ce-info="ceInfo"
                :user-state="userState"
                :user-profession="userProfession"
                :session-count="Object.keys(sessions).length"
                :master-course-id="masterCourseId"
                :thumbnail="thumbnail"
                :course-title="title"
                :preview-id="previewId"
                :path-details="{ $route, from }"
                :course-test="courseExperiment === 'B'"
                @update="updateCeInfo"
                @show-ce-tab="toggleCeTab"
              />
            </div>
            <div v-if="Object.keys(sessions).length > 0">
              <div
                v-if="!isBrochure"
                id="select-format"
                class=" md:border-b-2 border-matte-gray md:pl-4 md:py-2"
              >
                <div class="md:flex md:justify-between md:items-center">
                  <h5 class="hidden md:block leading-loose">
                    Select a Format
                  </h5>
                  <div
                    id="setting"
                    class="font-bold justify-between items-center text-white bg-background-primary text-left block md:hidden w-full py-4 px-6 border hover:opacity-75 focus:outline-none text-xl"
                  >
                    <span>
                      Select Format
                    </span>
                  </div>
                </div>
                <ul class="md:flex pt-4">
                  <li
                    v-for="format in productTypes"
                    :id="format"
                    :key="format"
                    :class="{ 'border-primary-140 rounded' : selectedFormat === format }"
                    class="font-bold p-2 px-4 mx-3 mlt-0 border-2 rounded cursor-pointer flex justify-start items-center"
                    @click="changeFormat(format, null)"
                  >
                    <img
                      :src="getIcon(format)"
                      :alt="format"
                      class="h-8 mr-2"
                    />{{ format === 'LIVE' ? 'IN-PERSON' : format }}
                  </li>
                </ul>
              </div>
              <div
                id="select-ceus"
                class="md:border-b-2 border-matte-gray md:pl-4 md:py-2"
              >
                <div v-if="isBrochure">
                  <div class="py-2 px-4 border-2 border-primary-140 rounded">
                    <div class="flex justify-start items-center">
                      <div class="rounded-lg bg-summit-green text-white font-bold text-xs py-1 px-2 mr-2">
                        NEW
                      </div>
                      <p
                        v-if="(!auth.loggedIn && freeTrialMarketing) || (auth.loggedIn && user?.freeTrialVoucherCount > 0)"
                        class="font-bold text-summit-green"
                      >
                        In-Person Options: Attend for FREE!
                      </p>
                      <div
                        v-else
                        class="font-bold text-summit-green"
                      >
                        <p v-if="selectedFormat === 'LIVE'">
                          In-Person Options!
                        </p>
                        <p v-else-if="selectedFormat === 'LIVESTREAM'">
                          Livestream Options!
                        </p>
                      </div>
                    </div>
                    <p v-if="!auth.loggedIn && freeTrialMarketing">
                      Join us for an all new 2- or 3-hour in-person course, completely free to you! If you already have a Summit account,
                      <a
                        id="course-log-in"
                        class="font-bold text-text-secondary"
                        @click.prevent="toggleLoginModal"
                      >login</a>
                      and you'll be returned to this page. If you are new to Summit,
                      <a
                        id="course-log-in"
                        class="font-bold text-text-secondary"
                        @click.prevent="createAccountRedirect"
                      >create an account</a>,
                      login and then select a course to attend for free.
                    </p>
                    <p v-else-if="auth.loggedIn && user?.freeTrialVoucherCount > 0">
                      Join us for an all new 2- or 3-hour in-person course, completely free to you! Select a course below
                      and click the "Register for Free!" button to redeem your free course registration. Questions?
                      <nuxt-link
                        to="/support"
                        target="_blank"
                      >
                        We're here to help.
                      </nuxt-link>
                    </p>
                    <div v-else>
                      <p v-if="selectedFormat === 'LIVE'">
                        Same location, multiple courses, different lengths. Take one or all.
                      </p>
                      <p v-else-if="selectedFormat === 'LIVESTREAM'">
                        Same experience, multiple courses, different lengths. Take one or all.
                      </p>
                    </div>
                  </div>
                </div>
                <h5 class="hidden md:block leading-loose">
                  Select Length
                </h5>
                <div
                  class="font-bold justify-between items-center text-white bg-background-primary text-left block md:hidden w-full py-4 px-6 border hover:opacity-75 focus:outline-none text-xl"
                >
                  <span>
                    Select Length
                  </span>
                </div>
                <div class="p-2 items-center">
                  <div v-if="selectedFormat === 'LIVE' || (isBrochure && selectedFormat === 'LIVESTREAM')">
                    <div v-if="isBrochure">
                      <div
                        v-for="session in sessions[selectedFormat]"
                        :key="session.id"
                      >
                        <label class="flex items-start py-2">
                          <input
                            :id="session.id"
                            class="mt-1 mr-3 transform scale-125"
                            type="radio"
                            :value="session.id"
                            :checked="session.id === selectedSession.id"
                            @change="changeSession(selectedFormat, { target: { value: session.id } }); confirmationMsgBuilder();"
                          />
                          <b class="fit-content mr-4">{{ session.credits === 0 ? '1 Hour:' : session.credits + ' Hours:' }}</b>
                          <div>
                            <div
                              v-if="isIncludedInSubscription(selectedSession)"
                              class="text-sm"
                            >
                              <p
                                v-if="selectedFormat === 'LIVE'"
                                class="text-sm"
                              >
                                <span v-html="session.title" /> <br /> {{ session.city }}, {{ session.state }} - {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }}) <br />
                              </p>
                              <p
                                v-else-if="selectedFormat === 'LIVESTREAM'"
                                class="text-sm"
                              >
                                <span v-html="session.title" /> <br /> {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }}) <br />
                              </p>
                              <p class="text-sm">
                                <b class="line-through">Price:</b><span class="line-through">&nbsp;${{ selectedSession.price }}</span>
                                <span class="italic">Included in your subscription!</span>
                              </p>
                            </div>
                            <div v-else>
                              <p
                                v-if="selectedFormat === 'LIVE'"
                                class="text-sm"
                              >
                                <span v-html="session.title" /> <br /> {{ session.city }}, {{ session.state }} - {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }}) <br />
                              </p>
                              <p
                                v-else-if="selectedFormat === 'LIVESTREAM'"
                                class="text-sm"
                              >
                                <span v-html="session.title" />  <br /> {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }}) <br />
                              </p>
                              <div class="flex flex-row items-center">
                                <p class="text-sm pr-3">
                                  <b>Price:</b>
                                  <!-- line through prices for free courses -->
                                  <span
                                    :class="[auth.loggedIn && user?.freeTrialVoucherCount > 0 && session.freeTrial ? 'line-through' : '']"
                                  >${{ session.price }}</span>
                                </p>
                                <div
                                  v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && session.freeTrial"
                                  class="has-tooltip flex flex-row"
                                >
                                  <div class="rounded-lg bg-background-primary text-white font-bold text-xs py-1 px-2 mr-2">
                                    Free!
                                  </div>
                                </div>
                                <div
                                  v-else-if="session.feeCode === 'EAR'"
                                  class="has-tooltip flex flex-row"
                                >
                                  <div class="rounded-lg bg-background-primary text-white font-bold text-xs py-1 px-2 mr-2">
                                    Early Bird Rate!
                                  </div>
                                  <div class="tooltip rounded shadow-lg p-1 bg-gray-500 ml-28">
                                    <p class="text-white text-xs">
                                      Hurry! Price increases 14 days before the course date.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        v-for="(value, key, idx) in multiCourseSessions"
                        :key="key"
                      >
                        <label class="flex items-start py-2">
                          <input
                            class="mt-1 mr-3 transform scale-125"
                            type="radio"
                            :checked="multiCourseSessions[key].visible"
                            @click="revealDropdown(key)"
                            @change="radioSelect(multiCourseSessions[key].sessions[0].id, idx)"
                          />
                          <b class="fit-content mr-4">{{ value.sessions[idx] === 0 ? '1 Hour:' : value.sessions[idx].credits + ' Hours:' }}</b>
                          <div
                            v-if="isIncludedInSubscription(value.sessions[idx])"
                            class="text-sm"
                          >
                            <p class="text-sm">
                              <b>Full Course:</b> {{ value.sessions[idx].title }} <br />
                            </p>
                            <p class="text-sm">
                              <b class="line-through">Price:</b><span class="line-through">&nbsp;${{ value.sessions[idx].price }}</span>
                              <span class="italic">Included in your subscription!</span>
                            </p>
                          </div>
                          <div
                            v-else
                            class="text-sm"
                          >
                            <p class="text-sm">
                              <b>Full Course:</b> {{ value.sessions[idx].title }} <br />
                            </p>
                            <div class="flex flex-row items-center">
                              <p class="text-sm pr-3">
                                <b>Price:</b>
                                <span
                                  :class="[auth.loggedIn && user?.freeTrialVoucherCount > 0 && value.sessions[idx].freeTrial ? 'line-through' : '']"
                                >${{ selectedSession.price }}</span>
                              </p>
                              <div
                                v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && value.sessions[idx].freeTrial"
                                class="has-tooltip flex flex-row"
                              >
                                <div class="rounded-lg bg-background-primary text-white font-bold text-xs py-1 px-2 mr-2">
                                  Free!
                                </div>
                              </div>
                              <div
                                v-else-if="selectedSession.feeCode === 'EAR'"
                                class="has-tooltip flex flex-row"
                              >
                                <div class="rounded-lg bg-background-primary text-white font-bold text-xs py-1 px-2 mr-2">
                                  Early Bird Rate!
                                </div>
                                <div class="tooltip rounded shadow-lg p-1 bg-gray-500 ml-28">
                                  <p class="text-white text-xs">
                                    Hurry! Price increases 14 days before the course date.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        <transition
                          name="fade"
                          mode="in-out"
                        >
                          <div
                            v-if="(value.visible)"
                            class="relative"
                          >
                            <select
                              v-if="getSelected('state').length > 0"
                              :id="`live-session-select-${idx}`"
                              v-model="requestedSession"
                              class="p-5 font-bold border-2 border-matte-gray w-full active:border-2 active:border-primary-140"
                              @change="changeSession(selectedFormat, $event); confirmationMsgBuilder();"
                            >
                              <option
                                value="first"
                                disabled
                                selected
                              >
                                Select a Course Date
                              </option>
                              <!-- sessions[selectedFormat] is reactive, slice() splits the body so that the original body isn't changed. This could somehow be a computed property, this was the quick fix -->
                              <option
                                v-for="(session, index) in filteredSessions[selectedFormat].slice().sort(sortSessionByDate)"
                                :key="session.id"
                                :value="session.id"
                                :selected="index === 1"
                              >
                                {{ session.city }}, {{ session.state }} - {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }})
                              </option>
                            </select>
                            <select
                              v-else
                              :id="`live-session-select-${idx}`"
                              v-model="requestedSession"
                              class="p-4 font-bold border-2 border-matte-gray w-full active:border-2 active:border-primary-140"
                              @change="changeSession(selectedFormat, $event); confirmationMsgBuilder();"
                            >
                              <option
                                value="first"
                                disabled
                                selected
                              >
                                {{ selectedSession.city }}, {{ selectedSession.state }} - {{ formatDate(selectedSession.date) }} ({{ formatTime(selectedSession.timeStampStart) }} to {{ formatTime(selectedSession.timeStampEnd) }} {{ selectedSession.workshopTimezone }})
                              </option>
                              <!-- sessions[selectedFormat] is reactive, slice() splits the body so that the original body isn't changed. This could somehow be a computed property, this was the quick fix -->
                              <option
                                v-for="(session, index) in value.sessions.slice().sort(sortSessionByDate)"
                                :key="session.id"
                                :value="session.id"
                                :selected="index === 1"
                              >
                                {{ session.city }}, {{ session.state }} - {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} to {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }})
                              </option>
                            </select>

                            <div class="absolute flex inset-y-0 items-center px-3 right-0 text-gray-700 rounded-r pointer-events-none">
                              <t-icon
                                class="text-text-secondary"
                                name="chevron-down"
                              />
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="selectedFormat === 'LIVESTREAM'">
                    <label class="flex items-start py-2">
                      <input
                        class="mt-1 mr-3 transform scale-125"
                        type="radio"
                        checked="checked"
                      />
                      <b class="fit-content mr-4">{{ selectedSession.credits === 0 ? '1 Hour:' : selectedSession.credits + ' Hours:' }}</b>
                      <div
                        v-if="isIncludedInSubscription(selectedSession)"
                        class="text-sm"
                      >
                        <p class="text-sm">
                          <b>Full Course</b> <span v-html="selectedSession.title" />  <br />
                        </p>
                        <p class="text-sm">
                          <b class="line-through">Price:</b><span class="line-through text-cta-primary">&nbsp;${{ selectedSession.price }}</span>
                          <span class="italic">Included in your subscription!</span>
                        </p>
                      </div>
                      <div
                        v-else
                        class="text-sm"
                      >
                        <p class="text-sm">
                          <b>Full Course</b> <span v-html="selectedSession.title" />  <br />
                          <b>Price:</b>
                          <span>${{ selectedSession.price }}</span>
                        </p>
                      </div>
                    </label>
                  </div>
                  <div v-else-if="selectedFormat === 'WEBINAR'">
                    <label class="flex items-start py-2">
                      <input
                        class="mt-1 mr-3 transform scale-125"
                        type="radio"
                        checked="checked"
                      />
                      <b class="fit-content mr-4">{{ selectedSession.credits === 0 ? '1 Hour:' : selectedSession.credits + ' Hours:' }}</b>
                      <div
                        v-if="isIncludedInSubscription(selectedSession)"
                        class="text-sm"
                      >
                        <p class="text-sm">
                          <b>Full Course</b> <span v-html="selectedSession.title" /> <br />
                        </p>
                        <p class="text-sm">
                          <b class="line-through">Price:</b><span class="line-through">&nbsp;${{ selectedSession.price }}</span>
                          <span class="italic">Included in your subscription!</span>
                        </p>
                      </div>
                      <div
                        v-else
                        class="text-sm"
                      >
                        <p class="text-sm">
                          <b>Full Course</b> <span v-html="selectedSession.title" /> <br />
                          <b>Price:</b>
                          <span>${{ selectedSession.price }}</span>
                        </p>
                      </div>
                    </label>
                  </div>
                  <div v-else>
                    <div
                      v-for="session in sessions[selectedFormat]"
                      :key="session.id"
                    >
                      <label class="flex items-start py-2">
                        <input
                          :id="session.id"
                          class="mt-1 mr-3 transform scale-125"
                          type="radio"
                          :value="session.id"
                          :checked="session.id === selectedSession.id"
                          @change="changeFormat(selectedFormat, session.id)"
                        />
                        <b class="fit-content mr-4">{{ session.credits === 0 ? '1 Hour:' : session.credits + ' Hours:' }}</b>
                        <div v-if="session.credits === 6">
                          <div
                            v-if="isIncludedInSubscription(session)"
                            class="text-sm"
                          >
                            <p class="text-sm">
                              <b>Full Course</b> <span v-html="session.title" /> <br />
                            </p>
                            <p class="text-sm">
                              <b class="line-through">Price:</b><span class="line-through">&nbsp;${{ session.price }}</span>
                              <span class="italic">Included in your subscription!</span>
                            </p>
                          </div>
                          <div v-else>
                            <p class="text-sm">
                              <b>Full Course</b> <span v-html="session.title" /> <br />
                              <b>Price:</b>
                              <span>${{ session.price }}</span>
                            </p>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            v-if="isIncludedInSubscription(session)"
                            class="text-sm"
                          >
                            <p class="text-sm">
                              <span v-html="session.title" /> <br />
                            </p>
                            <p class="text-sm">
                              <b class="line-through">Price:</b><span class="line-through">&nbsp;${{ session.price }}</span>
                              <span class="italic">Included in your subscription!</span>
                            </p>
                          </div>
                          <div
                            v-else
                            class="text-sm"
                          >
                            <p class="text-sm">
                              {{ session.title }} <br />
                              <b>Price:</b>
                              <span>${{ session.price }}</span>
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="flex items-center">
                  <div
                    v-if="(selectedFormat ==='WEBINAR' || selectedFormat === 'LIVESTREAM') && !isBrochure"
                    class="pb-2 w-full"
                  >
                    <div class="relative">
                      <select
                        id="session-select"
                        v-model="requestedSession"
                        class="p-4 pr-10 font-bold border-2 border-matte-gray w-full active:border-2 active:border-primary-140"
                        @change="changeSession(selectedFormat, $event);"
                      >
                        <option
                          value="first"
                          disabled
                          selected
                        >
                          {{ formatDate(selectedSession.date) }} ({{ formatTime(selectedSession.timeStampStart) }} - {{ formatTime(selectedSession.timeStampEnd) }} {{ selectedSession.workshopTimezone }})
                        </option>
                        <option
                          v-for="session in sessions[selectedFormat].slice().sort(sortSessionByDate)"
                          :key="session.id"
                          class="px-4"
                          :value="session.id"
                          :selected="session.id === requestedSession"
                        >
                          {{ formatDate(session.date) }} ({{ formatTime(session.timeStampStart) }} - {{ formatTime(session.timeStampEnd) }} {{ session.workshopTimezone }})
                        </option>
                      </select>

                      <div class="absolute flex inset-y-0 items-center px-3 right-0 text-gray-700 rounded-r pointer-events-none">
                        <t-icon
                          class="text-text-secondary"
                          name="chevron-down"
                        />
                      </div>
                    </div>
                    <div
                      v-if="selectedFormat ==='LIVESTREAM' && (selectedSession.isMultiCourseTour === true && !isBrochure)"
                      class="p-2 mt-2 border-2 border-primary-140 rounded grid grid-cols-12 grid-rows-1 items-center"
                    >
                      <p class="pr-4 col-span-8 text-sm">
                        This Course is part of a 2-Day In-Person Series.
                      </p>
                      <nuxt-link
                        :to="`/course/${selectedSession.brochureId}/${selectedSession.id}?type=brochure#LIVESTREAM`"
                        class="col-span-4 text-right"
                      >
                        <t-button
                          variant="ctaSecondary"
                          class="text-sm"
                        >
                          See All Courses <t-icon
                            name="chevron-right"
                            class="ml-2"
                          />
                        </t-button>
                      </nuxt-link>
                    </div>
                    <div class="max-h-96 text-ellipsis overflow-hidden border-t-2 border-matte-gray mt-2 md:mt-6">
                      <h5 class="leading-loose">
                        Highlights
                      </h5>
                      <div
                        class="highlights ml-2"
                        v-html="selectedSession.highlights"
                      />
                    </div>
                    <a
                      class="text-sm underline cursor-default"
                      @click="scrollToTab('#info')"
                    >
                      More Course Details
                    </a>
                  </div>
                  <div
                    v-else-if="selectedFormat === 'LIVE'"
                    class="pb-2"
                  >
                    <div>
                      <div v-if="selectedSession.id.startsWith('CANC')">
                        {{ insertNoteToDom(selectedSession.websiteRedirectNote) }}
                        <div
                          class="font-bold"
                          v-html="websiteNoteElements"
                        />
                      </div>
                      <div
                        v-if="selectedSession.available <= 0 && !selectedSession.id.startsWith('CANC')"
                        class="py-4"
                      >
                        <p class="font-bold">
                          This course date is at full capacity and not available for registration at this time
                        </p>
                      </div>
                      <div v-if="selectedSession.facility.name !== ''">
                        <p
                          v-if="isBrochure"
                          class="font-bold"
                        >
                          Hotel Information:
                        </p>
                        <p class="text-sm pt-2">
                          {{ selectedSession.facility.name }}, <br />{{ selectedSession.facility.address1 }}, {{ selectedSession.facility.city }}, {{ selectedSession.facility.state }},
                          {{ selectedSession.facility.zip }}
                          <a
                            href="#facility-info"
                            class="text-sm"
                          >(Map)</a>
                          <br />
                          {{ formatTime(selectedSession.timeStampStart) }} - {{ formatTime(selectedSession.timeStampEnd) }} {{ selectedSession.workshopTimezone }}
                        </p>
                      </div>
                      <div v-if="requestedSession !== 'first' && selectedSession.facility.name === '' && !selectedSession.id.startsWith('CANC') && selectedSession.available > 0">
                        <p class="text-xs pt-2">
                          A facility has yet to be booked for this course but registration is open. You will be notified via email after a facility is selected.
                        </p>
                      </div>
                      <div
                        v-if="selectedSession.isMultiCourseTour === true && !isBrochure"
                        class="p-2 mt-2 border-2 border-primary-140 rounded grid grid-cols-12 grid-rows-1 items-center"
                      >
                        <p class="pr-4 col-span-8 text-sm">
                          This Course is part of a 2-Day In-Person Series.
                        </p>
                        <nuxt-link
                          :to="`/course/${selectedSession.brochureId}/${selectedSession.id}?type=brochure#LIVE`"
                          class="col-span-4 text-right"
                        >
                          <t-button
                            variant="ctaSecondary"
                            class="text-sm"
                          >
                            See All Courses <t-icon
                              name="chevron-right"
                              class="ml-2"
                            />
                          </t-button>
                        </nuxt-link>
                      </div>
                      <p class="text-xs pt-2">
                        In-person courses are now paperless <a
                          href="/live"
                          class="text-xs"
                        >(read more)</a> and <strong>you must know your Summit account username and password to sign in when you arrive at the course.</strong> You must be pre-registered; <strong>walk-ins are not accepted.</strong>
                      </p>
                    </div>
                    <div class="max-h-96 text-ellipsis overflow-hidden border-t-2 border-matte-gray mt-2 md:mt-6">
                      <h5 class="leading-loose">
                        Highlights
                      </h5>
                      <div
                        class="highlights ml-2"
                        v-html="selectedSession.highlights"
                      />
                    </div>
                    <a
                      class="text-sm underline cursor-default"
                      @click="scrollToTab('#info')"
                    >
                      More Course Details
                    </a>
                  </div>
                  <div v-else>
                    <div class="max-h-96 overflow-hidden border-t-2 border-matte-gray mt-4 md:mt-6">
                      <h5 class="leading-loose">
                        Highlights
                      </h5>
                      <div
                        class="highlights ml-4"
                        v-html="selectedSession.highlights"
                      />
                    </div>
                    <a
                      class="text-sm underline cursor-default"
                      @click="scrollToTab('#info')"
                    >
                      More Course Details
                    </a>
                  </div>
                </div>
              </div>
              <div
                v-if="isValidSubscription()"
                id="select-payment-subscriber"
                class="py-2"
              >
                <div class="md:flex-col md:justify-between md:items-center py-2">
                  <div class="pl-4 inline-flex flex-row">
                    <div>
                      <h5 class="md:py-2 leading-loose">
                        Hi {{ user.first_name }}!
                      </h5>
                    </div>
                    <div>
                      <p class="pl-2 pt-2 md:pt-4 md:pl-2">
                        <strong>Subscriber:</strong> S{{ user.person_id }}
                      </p>
                    </div>
                  </div>
                  <div class="text-right sm:pr-2 md:pr-0 py-2">
                    <div v-if="selectedSession.purchased">
                      This course is already in your account. Click
                      <nuxt-link
                        class="font-bold text-text-secondary"
                        to="/account/enrolled"
                      >
                        here
                      </nuxt-link>
                      to visit your account to access this course
                    </div>
                    <div v-else>
                      <div v-if="loading">
                        <div class=" flex justify-center items-center">
                          <div class="animate-spin rounded-full h-10 w-10 mr-4 border-b-2 border-matte-gray" />
                          <h6>Processing...</h6>
                        </div>
                      </div>
                      <div v-else-if="redirectLoading">
                        <div class=" flex justify-center items-center">
                          <div class="animate-spin rounded-full h-10 w-10 mr-4 border-b-2 border-matte-gray" />
                          <h6>Redirecting to your account...</h6>
                        </div>
                      </div>
                      <p
                        v-else-if="isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone)"
                        class="font-bold"
                      >
                        This course starts soon or has already started. If you'd like to register, please call Summit Customer Service <br class="sm:hidden" />at (800) 433-9570 to register.
                      </p>
                      <div v-else-if="isIncludedInSubscription(selectedSession)">
                        <t-button
                          v-if="selectedFormat === 'LIVE'"
                          :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 ||isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) }"
                          @click="goToLive('SUBALLACCESS');"
                        >
                          Add to My Subscription
                          <t-icon
                            class="ml-2 mt-1"
                            name="chevron-right"
                          />
                        </t-button>
                        <t-button
                          v-else-if="!loading"
                          :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) }"
                          @click="addToSubscription(selectedSession);"
                        >
                          Add to My Subscription
                          <t-icon
                            class="ml-2 mt-1"
                            name="chevron-right"
                          />
                        </t-button>
                        <div v-else>
                          <div class=" flex justify-center items-center">
                            <div class="animate-spin rounded-full h-10 w-10 mr-4 border-b-2 border-matte-gray" />
                            <h6>Processing...</h6>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div>
                          <p class="py-2">
                            Your current subscription does not include this course. Please contact customer service at (800) 433-9570 for easy upgrade options!
                          </p>
                          <div class="flex justify-between items-center py-4 md:py-0">
                            <div class=" w-full border-t-2 border-matte-gray mt-3 mr-5" />
                            <p class="font-bold text-center">
                              OR
                            </p>
                            <div class=" w-full border-t-2 border-matte-gray mt-3 ml-5" />
                          </div>
                          <div class="md:flex md:justify-between md:items-center pl-4 py-2">
                            <div class="justify-between items-center py-2 md:py-0">
                              <h6 class="font-bold py-2">
                                Purchase this Single Course
                              </h6>
                            </div>
                            <div
                              v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && selectedSession.freeTrial"
                              class="md:flex-col md:justify-between md:items-center py-2 md:py-0"
                            >
                              <t-button
                                v-if="btnState === 'addToCart'"
                                id="cart-btn"
                                class="text-sm"
                                :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                                variant="ctaPrimary"
                                :loading="loadingItem"
                                @click="addToSubscription(selectedSession);"
                              >
                                Register for Free!
                              </t-button>
                            </div>
                            <div
                              v-else
                              class="md:flex-col md:justify-between md:items-center py-2 md:py-0"
                            >
                              <t-button
                                v-if="btnState === 'addToCart'"
                                id="cart-btn"
                                class="text-sm mt-4 md:mt-0"
                                :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                                variant="ctaPrimary"
                                :loading="loadingItem"
                                @click="addItemToCart();"
                              >
                                Add to cart - ${{ selectedSession.price }}
                              </t-button>
                              <t-button
                                v-else-if="btnState === 'checkout'"
                                class="text-sm mt-4 md:mt-0"
                                variant="ctaSecondary"
                                :loading="loadingItem"
                                @click="proceedToCheckout()"
                              >
                                Go to checkout
                              </t-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                id="select-payment"
                class="md:pl-4 md:py-2"
              >
                <div v-if="!isBrochure">
                  <div
                    class="fixed bottom-0 left-0 right-0 z-40 w-full md:hidden"
                  >
                    <t-button
                      class="block md:hidden w-full py-4"
                      variant="ctaPrimary"
                      @click.prevent="showPurchaseOptions = !showPurchaseOptions"
                    >
                      Purchase Options
                      <t-icon
                        :name="!showPurchaseOptions ? 'chevron-right' : 'chevron-down'"
                        class="ml-2"
                      />
                    </t-button>
                    <div
                      v-show="showPurchaseOptions"
                      class="block bg-white md:hidden p-2"
                    >
                      <div class="md:flex md:justify-between md:items-center p-4 border-2 rounded border-matte-gray">
                        <div>
                          <h6 class="text-text-secondary font-bold">
                            I'm Already a Subscriber
                          </h6>
                          <p class="text-sm mb-2 md:mb-0">
                            Please log in to Summit to add this course to your account.
                          </p>
                        </div>

                        <t-button
                          variant="ctaSecondaryOutlined"
                          @click.prevent="toggleLoginModal"
                        >
                          Log in
                        </t-button>
                      </div>
                      <div class="md:flex md:justify-between md:items-center p-4 border-2 rounded border-matte-gray mt-4">
                        <div>
                          <h6 class="text-text-secondary font-bold">
                            Subscribe Today
                          </h6>
                          <p class="text-sm mb-2 md:mb-0">
                            The Best Value in CE! This course and hundreds more with a Summit Subscription.
                          </p>
                        </div>
                        <t-button
                          variant="ctaPrimary"
                          @click.prevent="showModal = !showModal"
                          @click="scrollToTab('#subOptions'); showPurchaseOptions=false"
                        >
                          See Subscriptions
                        </t-button>
                      </div>
                      <div class="flex justify-between items-center py-2">
                        <div class=" w-full border-t-2 border-matte-gray mt-3 mr-5" />
                        <p class="font-bold text-center">
                          OR
                        </p>
                        <div class=" w-full border-t-2 border-matte-gray mt-3 ml-5" />
                      </div>
                      <div
                        v-if="!isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone)"
                        class="md:flex md:justify-between md:items-center mb-4 md:mb-0"
                      >
                        <div class="flex justify-between items-center">
                          <h6 class="font-bold mb-2 md:mb-0">
                            Purchase this Single Course
                          </h6>
                        </div>
                        <div
                          v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && selectedSession.freeTrial"
                          class="md:flex md:justify-between md:items-center"
                        >
                          <t-button
                            id="cart-btn"
                            class="text-sm"
                            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                            variant="ctaPrimary"
                            :loading="loadingItem"
                            @click="addToSubscription(selectedSession);"
                          >
                            Register for Free!
                          </t-button>
                        </div>
                        <div
                          v-else
                          class="md:flex md:justify-between md:items-center"
                        >
                          <t-button
                            id="cart-btn"
                            class="text-sm"
                            :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                            variant="ctaPrimary"
                            :loading="loadingItem"
                            @click="addCartItem(selectedSession)"
                          >
                            Add to cart - ${{ selectedSession.price }}
                          </t-button>
                        </div>
                        <div class="mt-4">
                          <h6 class="font-bold mb-2 md:mb-0">
                            Group/Corporate Solutions: <br />
                            (615) 647-8486
                          </h6>
                          <t-button
                            variant="ctaPrimary"
                            class="text-sm"
                            @click.prevent="$router.push('/group-sales')">
                            Learn More <t-icon
                              name="chevron-right"
                              class="mr-2 text-sm" />
                          </t-button>
                        </div>
                      </div>
                      <div v-else>
                        <br />
                        <p class="font-bold">
                          This course starts soon or has already started. If you'd like to register, please call Summit Customer Service at (800) 433-9570 to register.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-start">
                    <t-button
                      class="hidden md:block leading-loose"
                      variant="ctaPrimary"
                      @click.prevent="showPurchaseOptions = !showPurchaseOptions"
                    >
                      Purchase Options <t-icon
                        name="chevron-right"
                        class="ml-2"
                      />
                    </t-button>
                    <p
                      v-if="!auth.loggedIn.value"
                      class="leading-loose text-xs"
                    >
                      Summit Subscriber?
                      <a
                        id="course-log-in"
                        class="font-bold text-text-secondary text-xs"
                        @click.prevent="toggleLoginModal"
                      >
                        Log in
                      </a>
                      to add this course.
                    </p>
                  </div>
                  <div
                    v-show="showPurchaseOptions"
                    class="hidden md:block p-2"
                  >
                    <div class="md:flex md:justify-between md:items-center p-4 border-2 rounded border-matte-gray">
                      <div>
                        <h6 class="text-text-secondary font-bold">
                          I'm Already a Subscriber
                        </h6>
                        <p class="text-sm">
                          Please log in to Summit to add this course to your account.
                        </p>
                      </div>
                      <t-button
                        variant="ctaSecondaryOutlined"
                        @click.prevent="toggleLoginModal"
                      >
                        Log in
                      </t-button>
                    </div>
                    <div class="md:grid md:grid-cols-12 md:grid-rows-1 md:justify-between md:items-center p-4 border-2 rounded border-matte-gray mt-4">
                      <div class="md:col-span-8">
                        <h6 class="text-text-secondary font-bold">
                          Subscribe Today
                        </h6>
                        <p class="text-sm">
                          The Best Value in CE! This course and hundreds more with a Summit Subscription.
                        </p>
                      </div>
                      <t-button
                        variant="ctaPrimary"
                        class="md:col-span-4"
                        @click.prevent="showModal = !showModal"
                        @click="scrollToTab('#subOptions')"
                      >
                        See Subscriptions
                      </t-button>
                    </div>
                    <div class="flex justify-between items-center py-4 md:py-0">
                      <div class=" w-full border-t-2 border-matte-gray mt-3 mr-5" />
                      <p class="font-bold text-center">
                        OR
                      </p>
                      <div class=" w-full border-t-2 border-matte-gray mt-3 ml-5" />
                    </div>
                    <div
                      v-if="!isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone)"
                      class="md:flex md:justify-between md:items-center py-2"
                    >
                      <div class="flex justify-between items-center py-4 md:py-0">
                        <h6 class="font-bold">
                          Purchase this Single Course
                        </h6>
                      </div>
                      <div
                        v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && selectedSession.freeTrial"
                        class="md:flex md:justify-between md:items-center py-2"
                      >
                        <t-button
                          id="cart-btn"
                          class="text-sm"
                          :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                          variant="ctaPrimary"
                          :loading="loadingItem"
                          @click="addToSubscription(selectedSession);"
                        >
                          Register for Free!
                        </t-button>
                      </div>
                      <div
                        v-else
                        class="md:flex md:justify-between md:items-center py-2"
                      >
                        <t-button
                          id="cart-btn"
                          class="text-sm mt-4 md:mt-0"
                          :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                          variant="ctaPrimary"
                          :loading="loadingItem"
                          @click="addCartItem(selectedSession)"
                        >
                          Add to cart - ${{ selectedSession.price }}
                        </t-button>
                      </div>
                    </div>
                    <div v-else>
                      <br />
                      <p class="font-bold">
                        This course starts soon or has already started. If you'd like to register, please call Summit Customer Service at (800) 433-9570 to register.
                      </p>
                    </div>
                    <div class="group-sales-contact md:flex md:justify-between md:items-center py-2">
                      <div class="justify-between items-center py-2 md:py-0">
                        <h6 class="font-bold py-2">
                          Group/Corporate Solutions: <br />
                          (615) 647-8486
                        </h6>
                      </div>
                      <t-button
                        variant="ctaPrimary"
                        class="text-sm"
                        @click.prevent="$router.push('/group-sales')">
                        Learn More <t-icon
                          name="chevron-right"
                          class="mr-2 text-sm" />
                      </t-button>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex justify-between items-center">
                    <p class="text-text-secondary text-xl font-bold">
                      “All Access” Subscription
                    </p>
                    <div>
                      <p class="text-sm">
                        Already a Summit Subscriber?
                        <t-button
                          variant="ctaSecondaryOutlined"
                          @click.prevent="toggleLoginModal"
                        >
                          Log in
                        </t-button>
                      </p>
                    </div>
                  </div>
                  <p class="mb-4">
                    Unlock unlimited access to these and all other courses! Just ${{ allAccess }}/year.
                  </p>
                  <div class="flex justify-between items-center">
                    <div>
                      <ul>
                        <li>
                          <t-icon
                            name="check"
                            class="text-text-secondary mr-2"
                          />{{ inPersonCourses }}+ In-Person Courses Annually
                        </li>
                        <li>
                          <t-icon
                            name="check"
                            class="text-text-secondary mr-2"
                          />{{ liveWebinars }}+ Live Interactive Webinar Annually
                        </li>
                        <li>
                          <t-icon
                            name="check"
                            class="text-text-secondary mr-2"
                          />
                          {{ liveStreams }}+ Live Streams Annually
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul>
                        <li>
                          <t-icon
                            name="check"
                            class="text-text-secondary mr-2"
                          />{{ onlineCourses }}+ Online Video/Text Courses
                        </li>
                        <li>
                          <t-icon
                            name="check"
                            class="text-text-secondary mr-2"
                          />Certification Series In 15 Practice Areas
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="flex justify-between items-center mt-4">
                    <t-button
                      class="text-sm mt-4 md:mt-0"
                      variant="ctaPrimary"
                      @click="subscribeNow('SUBALLACCESS');"
                    >
                      Subscribe Now - ${{ allAccess }} <t-icon
                        name="chevron-right"
                        class="ml-2"
                      />
                    </t-button>
                    <div
                      v-if="auth.loggedIn && user?.freeTrialVoucherCount > 0 && selectedSession.freeTrial"
                      class="md:flex-col md:justify-between md:items-center py-2 md:py-0"
                    >
                      <t-button
                        v-if="btnState === 'addToCart'"
                        id="cart-btn"
                        class="text-sm"
                        :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                        variant="ctaPrimary"
                        :loading="loadingItem"
                        @click="addToSubscription(selectedSession);"
                      >
                        Register for Free!
                      </t-button>
                    </div>
                    <div
                      v-else
                      class="md:flex-col md:justify-between md:items-center py-2 md:py-0"
                    >
                      <t-button
                        v-if="btnState === 'addToCart'"
                        id="cart-btn"
                        class="text-sm mt-4 md:mt-0"
                        :class="{ disabled: selectedSession.id.startsWith('CANC') || selectedSession.available <= 0 || isTwoHoursBeforeStartTime(selectedSession.timeStampStart, selectedSession.workshopTimezone) || checkItemSelected() }"
                        variant="ctaPrimaryOutlined"
                        :loading="loadingItem"
                        @click="addItemToCart();"
                      >
                        Add to cart - ${{ selectedSession.price }}
                      </t-button>
                      <t-button
                        v-else-if="btnState === 'checkout'"
                        class="text-sm mt-4 md:mt-0"
                        variant="ctaSecondary"
                        :loading="loadingItem"
                        @click="proceedToCheckout()"
                      >
                        Continue to checkout
                      </t-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="grid place-items-center"
            >
              <h3>
                <a
                  href="mailto:groups@summit-education.com"
                  target="_blank"
                  class="underline text-2xl mr-2"
                >Contact us </a>
                if you are interested in a Private In-Person Event
              </h3>
            </div>
          </div>
          <div
            v-if="selectedFormat === 'LIVE' && selectedSession.facility.name !== ''"
            id="facility-info"
            class="pt-2"
          >
            <l-map-details
              :facility="selectedSession.facility"
              :time-stamp-start="formatTime(selectedSession.timeStampStart)"
              :time-stamp-end="formatTime(selectedSession.timeStampEnd)"
              :workshop-timezone="selectedSession.workshopTimezone"
            />
          </div>
          <div
            v-if="Object.keys(sessions).length > 0"
            id="info"
            class="md:pt-20"
          >
            <h2 class="leading-loose text-xl md:text-4xl">
              Additional Information
            </h2>
            <course-tabs
              :master-course-id="route.params.courseId"
              :session="selectedSession"
              :ce-info="ceInfo"
              :asha-review="ashaReview"
              :selected="selectedTab"
              @input="setTab($event)"
            />
          </div>
          <l-course-recommender-scroll-bar :session-id="selectedSession.id" />
          <div
            v-if="Object.keys(reviews).length !== 0"
            id="reviews"
            class="md:pt-20"
          >
            <h2>Reviews</h2>
            <t-card class="p-3 mt-4">
              <div>
                <!-- Display paginated reviews -->
                <div
                  v-for="(review, index) in paginatedReviews"
                  :key="index"
                  class="py-2"
                >
                  <!--  TODO: commenting out not sure what this was doing  :v-model="currentPage" -->
                  <div class="md:flex md:items-center">
                    <div class="px-1 flex items-center">
                      <l-rating-stars
                        :rating="review.rating"
                        class="text-accent-light pr-1"
                      />
                      <p>{{ review.rating }}/5 {{ review.reviewId }}</p>
                    </div>
                    <div class="px-1">
                      <p>{{ review.firstName }} ({{ review.state }}) on {{ review.submitted }}</p>
                    </div>
                  </div>
                  <p>{{ review.reviewText }}</p>
                </div>
                <hr />
                <t-pagination
                  v-model="currentPage"
                  :items-per-page="itemsPerPage"
                  :total-items="reviews.length"
                  :default-page="1"
                  :show-first-last="true"
                  @page-changed="updateReviewsPage"/>
              </div>
            </t-card>
          </div>
        </t-container>
        <div class="bg-primary">
          <t-container class="py-5 md:py-10 grid grid-row-1 grid-cols-1 md:grid-cols-2 items-center">
            <h4 class="text-white text-center md:text-left text-lg md:text-2xl">
              Unlock Unlimited CE Courses with Summit Subscription
            </h4>
            <nuxt-link to="/subscription/subscription-v2">
              <h5 class="text-white font-bold text-center md:text-right">
                Pick Your Plan & Sign Up Today!
                <t-icon
                  class="text-white"
                  name="chevron-right"
                />
              </h5>
            </nuxt-link>
          </t-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Convert the hash values into an object:
// #live/ABC123.1.1CREDIT/true -> { 'format': 'live', 'sessionId': 'ABC123.1.1CREDIT', 'ashaReview': true }
import { DateTimeFormatter, LocalDateTime, ZonedDateTime, ZoneId, } from '@js-joda/core';
import { Locale, } from '@js-joda/locale_en-us';
import '@js-joda/timezone';
import { mapState, mapActions, mapStores, } from 'pinia';
import useFetchCustom from '../../../composables/useFetchCustom';
import { orderCreated, } from '~/services/iterable';
import { useMetricStore, } from '~/stores/metrics';
import { usePriceStore, } from '~/stores/prices';
import { useCartStore, } from '~/stores/cart';
import { useSearchStore, } from '~/stores/search';
import { formatTime, formatDate, scrollToTab, } from '@/utils/reusedFunctions';
import { eecCourseDetail, eecDetail, } from '~/services/gtmManager';

function sortSessionsByDate(a, b) {
  return new Date(a.date).getTime() - new Date(b.date).getTime();
}

function getHash(routeQuery) {
  console.log('Route query: ' + JSON.stringify(routeQuery));
  if (typeof window === 'undefined') {
    console.log('WINDOW IS UNDEFINED');
    return {
      // eslint-disable-next-line no-constant-binary-expression
      ashaReview: routeQuery.ashaReview === 'true' ?? false,
    };
  }

  // zip 2 arrays, similar to python's zip function
  const zip = (a1, a2) => a1.map((e, i) => {
    // ashaReview needs to be a boolean, and not a string. This is the safest way of doing that because `Boolean('false')` returns `true`
    const val = e === 'ashaReview' && a2[i] ? a2[i] === 'true' : a2[i] ?? false;
    return [e, val];
  });

  // this will take a hash value and split by `/`
  const hashValues = (location.hash || '').replace('#', '').trim().split('/');

  // list of the keys that will be used in the hash, order matters here
  const hashKeys = [
    'format',
    'sessionId',
    'ashaReview',
  ];
  const hashMap = Object.fromEntries(zip(hashKeys, hashValues));
  // eslint-disable-next-line no-constant-binary-expression
  hashMap.ashaReview = routeQuery.ashaReview === 'true' ?? false;
  console.log(`Hash Values: ${JSON.stringify(hashMap)}`);
  // getHash gets called before we have sessionId accessible so this check prevents the split on false boolean
  if (hashMap.sessionId !== false) {
    // split on query param if coming from /s
    hashMap.sessionId = hashMap.sessionId.split('?')[0];
  }
  // convert the 2 zipped arrays into an object for easy data manipulation
  return hashMap;
}

// Get the selected session based on the values that are passed in. The main thing is checking to make
// sure a session id is actually returned. The first thing is to check if there are any credits being
// passed in, then we want to filter out the sessions that matches best to the data passed in.
function getSelectedSession(sessions, sessionId) {
  // just a safety check
  if (!sessions || sessions.length === 0) {
    return {};
  }
  sessions = sessions.sort(sortSessionsByDate);
  // setting this to the side for now, to make some of the next step easier. Because otherwise we would
  // have to call `session.id` in multiple locations, this allows to just do it once and if `id` is not
  // being used in the future then we can change it in one location.
  return !sessionId
    ? sessions[0]
    : sessions.find(session => session.id === sessionId) || sessions[0];
}

// as a basic note, this file is called `_slug.vue` because we want good SEO and a good way to to do
// that is to have an extra value in the url. This makes the course url something like the following:
// `/course/ABC123.1/understanding-basics` and this is how Nuxt handles dynamic urls. We have to create
// nested directories to get the full path. We really only care about the course id, but SEO wants the slug
export default {
  name: 'CourseIndex',

  // DATA RETURNED FROM SETUP IS NOT REACTIVE UNLESS YOU SET THE ref(); see: https://vuejs.org/api/composition-api-setup.html#basic-usage
  async setup() {
    const { $auth: auth } = useNuxtApp();
    const { user } = useNuxtApp().$auth;

    const route = useRoute();
    const router = useRouter();
    const { history } = useRouter().options;
    const from = history.state.back;
    console.log('course details setup', history);
    const selectedSession = ref({});
    const pageLoading = ref(true);

    function truncateDescription(description) {
      const maxLength = 157;
      if (description.length <= maxLength) {
        return description;
      }

      const truncated = description.substring(0, maxLength);
      const lastSpaceIndex = truncated.lastIndexOf(' ');

      if (lastSpaceIndex === -1) {
        return truncated + '...';
      }

      return truncated.substring(0, lastSpaceIndex) + '...';
    };

    try {
      // THERE'S AN ISSUE WITH RANDOM STATES BEING ADDED
      // THAT LEADS TO A PERSON LINKING TO #LIVE TO LAND IN A BROKEN PAGE
      // IF THE RANDOM STATE IS ONE WITHOUT A LIVE COURSE
      // --
      // LEAVING COMMENTED BECAUSE WE WANT TO RESUME THE STATE FILTERING LATER
      // --
      // if (Object.keys(store.state.search.state).length !== 0) {
      //   const data = await $axios.$get(`/course/${params.courseId}/${store.state.search.state.id}`);
      //   const reviews = await $axios.$get(`/reviews/${params.courseId}`);
      //   const hash = getHash();
      //   const selectedFormat = hash.format || data.productTypes[0];
      //   const exampleItems = [...Array(150).keys()].map(i => ({ id: (i + 1), name: 'Item ' + (i + 1) }));
      //   return {
      //     ...data,
      //     reviews,
      //     loadingItem: false,
      //     ceInfo: {},
      //     ashaReview: hash.ashaReview ?? false,
      //     selectedTab: 'description', // default tab to be selected
      //     selectedFormat,
      //     selectedSession: getSelectedSession(data.sessions[selectedFormat], hash.sessionId),
      //     isShow: false,
      //     selected: ![
      //       'LIVE', 'WEBINAR', 'LIVESTREAM',
      //     ].includes(selectedFormat)
      //       ? ''
      //       : 'first',
      //     requestedSession: ![
      //       'LIVE', 'WEBINAR', 'LIVESTREAM',
      //     ].includes(selectedFormat)
      //       ? ''
      //       : 'first',
      //     showSelectFormat: false,
      //     showSelectLength: false,
      //     showSelectPayment: false,
      //     brochureReady: false,
      //     exampleItems,
      //     pageOfItems: [],
      //     loading: false,
      //   };
      // } else {
      const hash = getHash(route.query);
      console.log('Attempting api call with url: ' + `/course/${route.params.courseId}/ALL?ashaReview=${hash.ashaReview}`);
      const data = await useFetchCustom('GET', `${route.query.type === 'brochure' ? `/b/${route.params.courseId}` : `/course/${route.params.courseId}/ALL`}`, {},
                                        { ashaReview: hash.ashaReview });
      console.log('data response', data);

      let multiCourseSessions = {};
      // this organizing is only being done for LIVE courses for multi course tours
      if (data.productTypes.includes('LIVE')) {
        data.sessions.LIVE.forEach((s) => {
          const sessionCourseIdKey = s.sessionCourseId;
          if (Object.keys(multiCourseSessions).length > 0) {
            // loop through keys to sort sessions to appropiate key
            Object.keys(multiCourseSessions).forEach((courseIdKey) => {
              // if the keys match, add the session to list, else create a new key
              if (courseIdKey === sessionCourseIdKey) {
                multiCourseSessions[courseIdKey].sessions.push(s);
              }
              else {
                multiCourseSessions = {
                  ...multiCourseSessions,
                  [sessionCourseIdKey]: {
                    sessions: [s],
                    visible: false,
                  },
                };
              }
            });
          }
          else {
            // empty so create the first key with the session value
            multiCourseSessions = {
              [sessionCourseIdKey]: {
                sessions: [s],
                visible: true,
              },
            };
          }
        });
      }
      const reviews = ref(await useFetchCustom('GET', `${route.query.type === 'brochure' ? `/reviews/${data.masterCourseId}` : `/reviews/${route.params.courseId}`}`, {}, {}));
      const currentPage = ref(1); // which page to start on for pagination
      const itemsPerPage = 10;
      const exampleItems = ref([...Array(150).keys()].map(i => ({ id: (i + 1), name: 'Item ' + (i + 1) })));
      const selectedTab = ref('description');
      const requestedSession = ref('');
      const selectedFormat = ref(!hash.format ? data.productTypes[0] : hash.format);
      selectedSession.value = getSelectedSession(data.sessions[selectedFormat.value], hash.sessionId);

      useHead({
        title: selectedSession.value.title + ' CE Course',
        meta: [
          { name: 'description', content: truncateDescription(selectedSession.value.seoDescription ?? selectedSession.value.description.trim()) },
          { property: 'og:title', content: selectedSession.value.title + ' CE Course' },
          { property: 'og:description', content: truncateDescription(selectedSession.value.seoDescription ?? selectedSession.value.description.trim()) },
        ],
      });
      pageLoading.value = false;
      return {
        ...data,
        auth,
        user,
        reviews,
        currentPage,
        itemsPerPage,
        ashaReview: hash.ashaReview ?? false,
        selectedFormat,
        selectedSession,
        requestedSession,
        selectedTab,
        exampleItems,
        pageLoading,
        multiCourseSessions,
        route,
        from,
      };
    }
    catch (e) {
      console.error(e);
      const error = useError();
      error.value = {
        statusCode: e.response.status,
        message: e.response.data.message,
      };
    }
  },
  data() {
    // for auto-filling CeValidator
    if (this.auth.loggedIn.value) {
      return {
        courseExperiment: '',
        showLoginModal: false,
        userState: {
          id: this.user.state,
        },
        userProfession: {
          id: this.user.title_code,
        },
        requestedSession: ![
          'LIVE', 'WEBINAR', 'LIVESTREAM',
        ].includes(this.selectedFormat)
          ? ''
          : 'first',
        showModal: false,
        loading: false,
        loadingItem: false,
        redirectLoading: false,
        showPurchaseOptions: false,
        freeTrialMarketing: this.route.query?.freeTrial ?? false,
        ceInfo: {},
        isBrochure: false,
      };
    }
    return {
      courseExperiment: 'A',
      userState: {
        id: '',
      },
      userProfession: {
        id: '',
      },
      showLoginModal: false,
      confirmationMsg: '',
      isShow: false,
      showSelectFormat: false,
      showSelectLength: false,
      showSelectPayment: false,
      brochureReady: false,
      isBrochure: false,
      pageOfItems: [],
      websiteNoteElements: '',
      showModal: false,
      itemSelected: false,
      loading: false,
      loadingItem: false,
      redirectLoading: false,
      showPurchaseOptions: false,
      formatProfession: '',
      // selectedTab: 'description', // default tab to be selected
      ceInfo: {},
      requestedSession: ![
        'LIVE', 'WEBINAR', 'LIVESTREAM',
      ].includes(this.selectedFormat)
        ? ''
        : 'first',
      filteredSessions: [],
      freeTrialMarketing: this.$route.query?.freeTrial ?? false,
    };
  },
  computed: {
    ...mapState(usePriceStore, ['allAccess']),
    ...mapState(useMetricStore, [
      'inPersonCourses', 'liveWebinars', 'liveStreams', 'onlineCourses',
    ]),
    ...mapState(useSearchStore, [
      'getSelected', 'page', 'PageType', 'getState', 'getProfession',
    ]),
    ...mapStores('experiments', ['experiments']),
    isCorePlus() {
      return this.getParts('subcore100plus_').includes(true);
    },
    isCore() {
      return this.getParts('subcore100_').includes(true);
    },
    isVirtual() {
      return this.getParts('subvirtual').includes(true);
    },
    paginatedReviews() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.reviews.slice(start, start + this.itemsPerPage);
    },
  },
  beforeMount() {
    console.log('before mount');
    if (this.route.query.type === 'brochure') {
      this.isBrochure = true;
    }
    const hash = getHash(this.route.query);
    // look for format in hash if not there remove format hash
    const foundFormat = this.productTypes.find(element => element === hash.format);
    if (!foundFormat) {
      hash.format = '';
    }
    this.selectedFormat = !hash.format ? this.productTypes[0] : hash.format;
    this.initializeSearchFilters();
    if (Object.keys(this.sessions).length < 1) {
      eecCourseDetail(this.route.fullPath, this.masterCourseId);
    }
    // no cached filter + Live format + no hashed sessionId
    if (this.getSelected('state').length > 0 && (Object.keys(this.sessions).includes('LIVE')) && !hash.sessionId && !hash.format && !this.isBrochure) {
      this.filteredSessions = [];
      this.filterSessions();
    }
    else if (hash.sessionId) { // ANY LINKS WITH SESSION (handles page refresh, still want to keep current selection)
      this.filteredSessions = { ...this.sessions };
      this.changeSession(hash.format, { target: { value: hash.sessionId } });
    }
    else { // default, no search filter; linked from course search
      this.filteredSessions = { ...this.sessions };
      this.changeSession(this.selectedFormat, { target: { value: this.filteredSessions[this.selectedFormat][0].id } });
    }
  },
  created() {
    this.btnState = 'addToCart';
  },
  // this gets called after all the data is loaded from the API call on page load, and because the `hash`
  // values don't get passed to the server we need to check them once the page is done loading. I did try
  // and do query string value updates, but that called the API every time the query string changed, and
  // seemed useless because all the data is already on the pages. This allows the hash to be updated on
  // the fly and only hit the API once on initial page load. It is a little complicated at first, but will
  // make sense after having to use it for a bit. I don't think all things should be stored in the hash,
  // but for the small things like selected session/credits.
  mounted() {
    if (this.getSelected('state').length === 1) {
      this.userState.id = this.getSelected('state')[0].id;
    }
    if (this.getSelected('profession').length === 1) {
      this.userProfession.id = this.getSelected('profession')[0].id;
    }
    console.log('attempting mounted get hash');
    const hash = getHash(this.route.query);
    console.log('finished mounted get hash');
    if (hash.sessionId) {
      this.requestedSession = hash.sessionId;
    }
    else {
      this.requestedSession = this.selectedSession.id;
    }
    localStorage.setItem('currentSelection', this.requestedSession);
    this.ashaReview = hash.ashaReview ?? false;
    // just call the normal change format function to make sure the hash is updated properly and things are moved properly
    this.onMountedChangeFormat(hash.format, hash.sessionId);
    this.$nextTick(this.confirmationMsgBuilder);
    this.$nextTick(this.pageLoading = false);
  },
  methods: {
    ...mapActions(useCartStore, ['addItem']),
    ...mapActions(useSearchStore, ['initializeSearchFilters']),
    scrollToTab,
    toggleLoginModal() {
      this.showLoginModal = !this.showLoginModal;
    },
    filterSessions() {
      console.log('filter sessions');
      console.log(this.sessions);
      const selected = this.selected('state');
      console.log(selected);
      const selectedIds = [];
      selected.forEach(arr => selectedIds.push(arr.id));
      console.log(selectedIds);
      const activeSessions = this.sessions[this.selectedFormat];
      this.filteredSessions[this.selectedFormat] = activeSessions.filter((s) => {
        return selectedIds.includes(s.state);
      });
      if (this.filteredSessions[this.selectedFormat].length > 0) {
        this.changeSession(this.selectedFormat, { target: { value: this.filteredSessions[this.selectedFormat][0].id } });
      }
      else {
        // removes in person/live section if there are no sessions
        this.productTypes = this.productTypes.filter(pt => pt !== 'LIVE');
      }
      console.log(this.filteredSessions);
    },
    revealDropdown(key) {
      Object.keys(this.multiCourseSessions).forEach((k) => {
        this.multiCourseSessions[k].visible = k === key;
      });
    },
    radioSelect(sessionId, idx) {
      const liveSessionSelect = document.getElementById('live-session-select-' + idx);
      liveSessionSelect.options[1].selected = true;
      this.changeSession(this.selectedFormat, { target: { value: sessionId } });
    },
    getParts(partPrefix) {
      const keys = Object.keys(this.selectedSession.allowedSubscriptions)
        .filter(key => key.startsWith(partPrefix));
      const values = [];
      keys.forEach(k => values.push(this.selectedSession.allowedSubscriptions[k]));
      return values;
    },
    formatDate,
    formatTime,
    // returns true if current zoned time is within 2 hours of session start time
    isTwoHoursBeforeStartTime(startDateTime, workshopTimezone) {
      const zonedTime = ZonedDateTime.now(ZoneId.of(workshopTimezone)).format(DateTimeFormatter.ofPattern('yyyy-MM-dd HH:mm:ss').withLocale(Locale.US));
      const currentTime = LocalDateTime.parse(zonedTime, DateTimeFormatter.ofPattern('yyyy-MM-dd HH:mm:ss').withLocale(Locale.US));
      const courseStart = LocalDateTime.parse(startDateTime, DateTimeFormatter.ofPattern('yyyy-MM-d h:mm a').withLocale(Locale.US));
      const allowedSignupTime = courseStart.minusHours(2);
      return currentTime.isAfter(allowedSignupTime);
    },
    isIncludedInSubscription(session) {
      if (!this.isValidSubscription()) {
        return false;
      }
      return session.allowedSubscriptions[this.auth.user.value.subscription_type] || (this.auth.user.value.allowed_products).includes(session.productType);
    },
    setTab(event) {
      this.selectedTab = event;
    },
    isValidSubscription() {
      return this.auth.loggedIn.value && this.auth.user.value.subscription_type && (this.auth.user.value.subscription_type).toUpperCase().startsWith('SUB');
    },
    onMountedChangeFormat(format, sessionId) {
      if (!format) {
        format = this.productTypes[0];
      }
      this.selectedFormat = format;
      this.selectedSession = getSelectedSession(this.sessions[format], sessionId);
    },
    changeFormat(format, sessionId) {
      if (!format) {
        // return;
        format = this.productTypes[0];
      }
      location.hash = '';
      this.selectedFormat = format;
      location.hash = format;
      if (screen.width < 768) {
        console.log(true);
        document.querySelector('#setting').scrollIntoView({ behavior: 'smooth' });
      }
      // resets selection dropdowns
      const previousSelection = localStorage.getItem('currentSelection');
      if (format.toString() === 'VIDEO' || format.toString() === 'TEXT') {
        this.requestedSession = '';
        this.selectedSession = getSelectedSession(this.sessions[format], sessionId);
        location.hash = `${format}/${this.selectedSession.id}`;
      }
      else {
        this.sessions[format].every((session) => {
          this.selectedSession = getSelectedSession(this.sessions[format], previousSelection);
          if (previousSelection === session.id) {
            this.selectedSession = session;
            this.requestedSession = previousSelection;
            location.hash = `${format}/${this.selectedSession.id}`;
            return false;
          }
          else {
            this.selectedSession = getSelectedSession(this.sessions[format], sessionId);
            this.requestedSession = this.selectedSession.id;
            location.hash = `${format}/${this.selectedSession.id}`;
            return true;
          }
        });
      }
      try {
        if (this.userProfession.id === 'PT/PTA') {
          this.formatProfession = 'PT-PTA';
        }
        else if (this.userProfession.id === 'OT/OTA') {
          this.formatProfession = 'OT-OTA';
        }
        else {
          this.formatProfession = this.userProfession.id;
        }
        const products = [
          {
            id: this.masterCourseId,
            name: this.title,
            category: this.formatProfession + '/' + this.selectedSession.productType + '/' + this.selectedSession.credits,
            variant: this.selectedSession.id,
            brand: 'Summit',
          },
        ];
        eecDetail('Course Search', products);
      }
      catch (e) {
        console.log('eec.impressionView error');
      }
    },
    changeSession(format, event) {
      if (!format) {
        return;
      }
      const selected = event.target.value;
      location.hash = '';
      this.selectedFormat = format;
      this.selectedSession = getSelectedSession(this.sessions[format], selected);
      if (this.isBrochure) {
        this.btnState = 'addToCart';
      }
      localStorage.setItem('currentSelection', this.selectedSession.id.toString());
      this.requestedSession = this.selectedSession.id; // v-model for select dropdowns
      location.hash = `${format}/${this.selectedSession.id}${this.ashaReview ? '/true' : ''}`;
      try {
        const products = [
          {
            id: this.masterCourseId,
            name: this.title,
            category: this.userProfession.id + '/' + this.selectedSession.productType + '/' + this.selectedSession.credits,
            variant: this.selectedSession.id,
            brand: 'Summit',
          },
        ];
        eecDetail('Course Search', products);
      }
      catch (e) {
        console.log('eec.impressionView error');
      }
    },
    sortSessionByDate(a, b) {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
    },
    checkItemSelected() {
      return (this.requestedSession === 'first');
    },
    getIcon(format) {
      return {
        // TODO Make sure these are pulling right icons
        'LIVE': '//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg',
        'LIVESTREAM': '//summitproedu.imgix.net/redesign-assets/icons/2025/live-stream.svg',
        'WEBINAR': '//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg',
        'TEXT': '//summitproedu.imgix.net/redesign-assets/icons/2025/text.svg',
        'VIDEO': '//summitproedu.imgix.net/redesign-assets/icons/2025/online_video.svg',
        'PODCAST': '//summitproedu.imgix.net/redesign-assets/icons/2025/podcast.svg',
      }[format] || '//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg';
    },
    async updateCeInfo(newCeInfo) {
      this.ceInfo = newCeInfo;
    },
    insertNoteToDom(websiteNote) {
      // split on the <br/>
      if (websiteNote.includes('<')) {
        let htmlString = websiteNote.split(/(<.*)/)[1];
        htmlString = htmlString.replace('<a', '<a class="underline text-text-secondary" '); // tried CSS div #id > a tag for the div this is held, but to no avail
        this.websiteNoteElements = htmlString;
        return websiteNote.split(/(<.*)/)[0];
      }
      return websiteNote;
    },
    // in the CE validation component, there is a button to change the tab to be the CE tab.
    toggleCeTab() {
      this.selectedTab = 'ce';
    },
    goToLive() {
      // TODO: make the confirm a toast message (would look prettier)
      if (this.confirmationMsg.includes('undefined') || this.confirmationMsg.includes('null')) {
        alert('There was an error, please refresh the page. If this does not resolve the issue, please contact customer service M-F 7am-6pm CST at (800) 433-9570');
      }
      else if (confirm(this.confirmationMsg)) {
        this.$router.push(`/live/in-person-waiver/${this.selectedSession.id}`);
      }
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    subscriberInfo() {
      switch (this.auth.user.value.subscription_type) {
        case 'suballaccess_sgl':
          return 'AA';
        case 'suballaccess':
          return 'AA';
        case 'subonlineaccess_sgl':
          return 'OA';
        case 'subonline':
          return 'OA';
        default:
          return 'none';
      }
    },
    confirmationMsgBuilder() {
      this.confirmationMsg = 'undefined';
      // const msgSelect = document.getElementById('session-select')?.options[document.getElementById('session-select').selectedIndex].text;
      // const msgSelect = '';
      // if (!msgSelect) {
      //   return;
      // }
      // const city = msgSelect.split('-')[0].trim();
      // const date = msgSelect.split('-')[1].trim();
      console.log('confirmation builder');
      console.log(JSON.parse(JSON.stringify(this.selectedSession)));
      const formattedDate = this.formatDate(this.selectedSession.date);
      if (this.isFreeSession()) {
        const startTimeStamp = this.selectedSession.timeStampStart;
        const startTime = startTimeStamp.substring(startTimeStamp.indexOf(' ') + 1);
        if (this.selectedSession.productType === 'LIVE') {
          this.confirmationMsg = `Would you like to use your free course registration towards this in-person course in ${this.selectedSession.city}, ${this.selectedSession.state} on ${formattedDate} at ${startTime}?`;
        }
        else if (this.selectedSession.productType.includes('WEBINAR' | 'LIVESTREAM')) {
          this.confirmationMsg = `Would you like to use your free course registration towards this course on ${formattedDate} at ${startTime}?`;
        }
        else {
          this.confirmationMsg = `Would you like to use your free course registration towards this online course?`;
        }
      }
      else {
        this.confirmationMsg = `Would you like to attend this in-person course in ${this.selectedSession.city}, ${this.selectedSession.state} on ${formattedDate}?`;
      }
    },
    isFreeSession() {
      console.log(this.selectedSession);
      return (!this.auth.loggedIn.value || this.auth.user.value.freeTrialVoucherCount > 0) && this.selectedSession.freeTrial;
    },
    isLoading() {
      return this.loading;
    },
    // go to free-course to register, then redirect to login, then redirect back after login
    async createAccountRedirect() {
      if (!this.auth.user.value) {
        const redirectLocation = this.isBrochure ? '/b/' + this.selectedSession.brochureId : '/course/' + this.masterCourseId;
        await this.$router.push({ name: 'free-course', query: { redirect: redirectLocation.toString() } });
      }
    },
    async subscribeNow(subscriptionId) {
      console.log('SUBSCRIBENOW: ' + JSON.stringify(subscriptionId));
      await this.addCartItem({ id: subscriptionId });
    },
    async buyNow() {
      await this.addCartItem(this.selectedSession);
    },
    async proceedToCheckout() {
      await this.goToCheckout(this.selectedSession);
    },
    // adds item to cart without going to cart
    async addItemToCart() {
      if (confirm(this.confirmationMsg)) {
        await this.continueBrowsing(this.selectedSession);
      }
    },
    async goToCheckout(session) {
      try {
        this.loadingItem = true;
        if (!this.isBrochure) {
          await this.addItem(session);
        }
        await this.$router.push('/cart');
      }
      catch (e) {
        // todo: show error message
        console.log('e =', e);
      }
      finally {
        this.loadingItem = false;
      }
    },
    async continueBrowsing(session) {
      // add selected session to the cart
      // then navigate to the cart page
      try {
        this.loadingItem = true;
        await this.addItem(session);
        await this.$router.push('/cart');
      }
      catch (e) {
        // todo: show error message
        console.log('e =', e);
      }
      finally {
        this.loadingItem = false;
      }
    },

    updateReviewsPage(page) {
      this.currentPage = page;
    },

    // adds item to cart, routes to /cart right after
    async addCartItem(session) {
      // add selected session to the cart
      // then navigate to the cart page
      try {
        this.loadingItem = true;
        await this.addItem(session);
        await nextTick(async() => await navigateTo('/cart'));
      }
      catch (e) {
        // todo: show error message
        console.log('e =', e);
      }
      finally {
        this.loadingItem = false;
      }
    },
    async addToSubscription(session) {
      console.log('ADDING TO SUBSCRIPTION');
      console.log(session.freeTrial);
      const msg = 'Would you like to add this ' + this.selectedSession.credits + ' hour ' + this.selectedFormat + ' to your subscription?';
      this.loading = true;
      const subscriptionRelevant = this.isIncludedInSubscription(session);
      const freeTrialEligible = (session.freeTrial && this.auth.user.value.freeTrialVoucherCount > 0);
      if (msg.includes('undefined') || msg.includes('null')) {
        alert('There was an error, please refresh the page. If this does not resolve the issue, please contact customer service M-F 7am-6pm CST at (800) 433-9570');
      }
      else if (subscriptionRelevant && confirm(msg)) {
        await useFetchCustom('POST', '/checkout/enroll/SUBs', { // normal add to sub
          sessionId: session.id,
        })
          .then((response) => {
            console.log(response);
            this.$router.push('/account');
          })
          .then(() => {
            this.loading = false;
            this.redirectLoading = true;
            orderCreated(this.auth.user.value.email);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      else if (freeTrialEligible && confirm(this.confirmationMsg)) { // free trial
        await useFetchCustom('POST', '/checkout/enroll/FT', {
          sessionId: session.id,
        })
          .then((response) => {
            console.log(response);
            this.auth.getSession();
            this.$router.push('/account');
          })
          .then(() => {
            this.loading = false;
            this.redirectLoading = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.$nextTick(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
#course-log-in {
  cursor: pointer;
}

.fit-content {
  min-width: fit-content;
}

.highlights ::v-deep ul {
  list-style: disc;
  padding-left: 10px;
}

label {
  color: black !important;
}

select::-ms-expand {
  display: none;
}

select {
  /* -webkit-appearance: none; */
  appearance: none;
}

select:focus {
  outline: none;
}

.tooltip {
  visibility: hidden;
  position: absolute;
}

.has-tooltip:hover .tooltip {
  visibility: visible;
  z-index: 50;
}
</style>
